import { constantRouterMap,asyncRouterRootMap, asyncRouterMap } from '../../router'
import { userGetMenue } from '../../api/configApi'
import router from '@/router'
import Home from '../../views/Home.vue'
import Main from '../../views/Main.vue'
/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(role => route.meta.roles.indexOf(role) >= 0)
  } else {
    return true
  }
}
export function generaMenu(routers, data){
  if(!data) return
  data.forEach(item => {
    if(item.component == 'Home'){
      var menu = {
        path: item.path,
        component: Home,
        hidden: item.hidden == 'false'? false : true,
        children: [],
        name: item.name,
        meta: { title: item.title, icon: item.icon, roles: ['common']}
      }
    }else if(item.component == 'Main'){
      var menu = {
        path: item.path,
        component:Main,
        hidden: item.hidden == 'false'? false : true,
        children: [],
        name: item.name,
        meta: { title: item.title, icon: item.icon, roles: ['common']}
      }
    }else{
      var menu = {
        path: item.path,
        component:(resolve) =>require([`@/views${item.path}`], resolve),
        hidden: item.hidden == 'false'? false : true,
        children: [],
        name: item.name,
        meta: { title: item.title, icon: item.icon, roles: ['common']}
      }
    }
     
    if (item.children!==null) {
      generaMenu(menu.children, item.children)
    }
    routers.push(menu)
  })
}
// let menuListdata =JSON.parse(sessionStorage.getItem('menuList'))
// console.log(asyncRouterMap)
// generaMenu(asyncRouterMap,menuListdata)
/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterRootMap, roles) {
  const accessedRouters = asyncRouterRootMap.filter(route => {
    if (hasPermission(roles, route)) {
      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}
const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers
      state.routers = constantRouterMap.concat(routers)
      router.addRoutes(state.routers)
    }
  },
  actions: {
    GenerateRoutes({ commit }, data) {
      return new Promise(resolve => {
        if(!data.roles.includes('root')){
          if(sessionStorage.getItem('menuList')){
            let menuList =JSON.parse(sessionStorage.getItem('menuList'))
            let routers = []
            generaMenu(routers, menuList)
            commit('SET_ROUTERS', routers)
            resolve()
          }else{
            userGetMenue().then(res=>{
              if(res.msg=='success'){
                console.log(res)
                sessionStorage.setItem('menuList', JSON.stringify(res.data.children))
                let routers = []
                generaMenu(routers, res.data.children)
                commit('SET_ROUTERS', routers)
                resolve()
              } else {
                resolve()
              }
            //     let accessedRouters
            //     let { roles } = data
            //     if (roles.includes('root')) {
            //       accessedRouters = asyncRouterMap || []
            //     } else {
            //       accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
            //       console.error(accessedRouters)
            //     }
            //     commit('SET_ROUTERS', accessedRouters)
            //     resolve(accessedRouters)
            //   }
            })
          }
          
        }else{
          let accessedRouters
          accessedRouters = asyncRouterRootMap || []
          let { roles } = data
          accessedRouters = filterAsyncRouter(asyncRouterRootMap, roles)
          console.log(accessedRouters)
          commit('SET_ROUTERS', accessedRouters)
          resolve()
        }
        // const { roles } = data
        // let accessedRouters
        // accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        // console.log(accessedRouters)
        // commit('SET_ROUTERS', accessedRouters)
        // resolve()
      })
    }
  }
}
export default permission



// WEBPACK FOOTER //
// ./src/store/modules/permission.js